module.exports = __webpack_public_path__ + "static/media/azon-thumb.761d47d4.png";